import { PropsWithChildren, useState } from "react"
import cn from "classnames"

import { useMediaIsMobile } from "utils/helpers"
import { VideoUserName } from "modules/Call/components/VideoUserName"
import { SafetyPopover } from "modules/Call/components/SafetyPopover"
import style from "modules/Call/components/VideoUserNameWithPopover/style.module.scss"

interface Props {
    className?: string
    popoverClassName?: string
    popoverBodyClassName?: string
    isIconOnly?: boolean
}

export function VideoUserNameWithPopover({
    children,
    className,
    popoverClassName,
    popoverBodyClassName,
    isIconOnly,
}: PropsWithChildren<Props>) {
    const [shown, setShown] = useState(false)
    const isMobile = useMediaIsMobile()

    return (
        <VideoUserName
            className={cn(className, { "is-invisible": shown })}
            key={`${isMobile.toString()}`}
        >
            <SafetyPopover
                placement="bottom"
                className={popoverClassName}
                iconClassName={cn({ [style.isSingle]: isIconOnly })}
                popoverBodyClassName={cn(style.hasBlurBg, popoverBodyClassName)}
                maxWidth={isMobile ? "100%" : 360}
                onToggle={setShown}
            >
                {children}
            </SafetyPopover>
        </VideoUserName>
    )
}
